import React, { useState, useEffect } from "react";
import Navbar from "../../Navbar/Navbar";
import {
    Box,
    Typography,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    CircularProgress,
    Button,
} from "@mui/material";
import axios from "axios";
import baseURL from "../../config";

const BusinessDevelopment = () => {
    const [mainOption, setMainOption] = useState("");
    const [shipOwners, setShipOwners] = useState([]);
    const [selectedShipOwners, setSelectedShipOwners] = useState([]);
    const [loading, setLoading] = useState(false);

    // Fetch Ship Owner list
    const fetchAllVesselData = async () => {
        const token = localStorage.getItem("token");
        try {
            setLoading(true);
            const response = await axios.get(
                `${baseURL}/api/vesselOwner/getVesselOwnerALL`,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );
            setShipOwners(response.data.data || []);
        } catch (error) {
            console.error("Error fetching vessel owners:", error);
        } finally {
            setLoading(false);
        }
    };

    // Run API when "Ship Owner" is selected
    useEffect(() => {
        if (mainOption === "Ship Owner") {
            fetchAllVesselData();
        }
    }, [mainOption]);

    // Handle Submit - Send Emails
    const handleSubmit = async () => {
        try {
            // Collect selected owners' emails
            const selectedEmails = shipOwners
                .filter((owner) => selectedShipOwners.includes(owner._id))
                .map((owner) => owner.email);

            console.log("Emails to send:", selectedEmails);

            if (selectedEmails.length === 0) {
                alert("Please select at least one Ship Owner.");
                return;
            }

            const token = localStorage.getItem("token");
            await axios.post(
                `${baseURL}/api/vesselOwner/business-dev`,   // ✅ matches backend
                { emails: selectedEmails },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            alert("Emails sent successfully!");
            setSelectedShipOwners([]);
        } catch (error) {
            console.error("Error sending emails:", error);
            alert("Failed to send emails.");
        }
    };

    return (
        <>
            <Navbar />
            <Box sx={{ p: 4, backgroundColor: "white", minHeight: "100vh" }}>
                <Typography
                    variant="h5"
                    gutterBottom
                    sx={{ fontWeight: "bold", color: "#C30B12" }}
                >
                    Business Development
                </Typography>

                {/* Main Dropdown */}
                <FormControl sx={{ mt: 3, minWidth: 300 }}>
                    <InputLabel sx={{ color: "#C30B12" }}>Select Option</InputLabel>
                    <Select
                        value={mainOption}
                        onChange={(e) => setMainOption(e.target.value)}
                        sx={{
                            "& .MuiSelect-select": { color: "#C30B12" },
                            "& .MuiOutlinedInput-notchedOutline": { borderColor: "#C30B12" },
                            "&:hover .MuiOutlinedInput-notchedOutline": {
                                borderColor: "gold",
                            },
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                borderColor: "gold",
                            },
                        }}
                    >
                        <MenuItem value="Ship Owner">Ship Owner</MenuItem>
                        <MenuItem value="To Crew">To Crew</MenuItem>
                        <MenuItem value="To Travel Agent">To Travel Agent</MenuItem>
                        <MenuItem value="To Marine Institute">To Marine Institute</MenuItem>
                    </Select>
                </FormControl>

                {/* Ship Owner Dropdown (multiple select) */}
                {mainOption === "Ship Owner" && (
                    <FormControl sx={{ mt: 3, minWidth: 300 }}>
                        <InputLabel sx={{ color: "#C30B12" }}>Select Ship Owners</InputLabel>
                        <Select
                            multiple
                            value={selectedShipOwners}
                            onChange={(e) => setSelectedShipOwners(e.target.value)}
                            disabled={loading}
                            sx={{
                                "& .MuiSelect-select": { color: "#C30B12" },
                                "& .MuiOutlinedInput-notchedOutline": { borderColor: "#C30B12" },
                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "gold",
                                },
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "gold",
                                },
                            }}
                            renderValue={(selected) =>
                                shipOwners
                                    .filter((owner) => selected.includes(owner._id))
                                    .map((owner) => owner.company_name)
                                    .join(", ")
                            }
                        >
                            {loading ? (
                                <MenuItem disabled>
                                    <CircularProgress size={20} sx={{ color: "#C30B12" }} />
                                </MenuItem>
                            ) : (
                                shipOwners.map((owner) => (
                                    <MenuItem key={owner._id} value={owner._id}>
                                        {owner.company_name}
                                    </MenuItem>
                                ))
                            )}
                        </Select>
                    </FormControl>
                )}

                {/* Submit Button */}
                {mainOption === "Ship Owner" && (
                    <Box sx={{ mt: 4 }}>
                        <Button
                            variant="contained"
                            sx={{
                                backgroundColor: "#C30B12",
                                color: "white",
                                "&:hover": { backgroundColor: "gold", color: "black" },
                            }}
                            onClick={handleSubmit}
                        >
                            Submit
                        </Button>
                    </Box>
                )}
            </Box>
        </>
    );
};

export default BusinessDevelopment;
